import styled from "styled-components";
import { WithStyles } from "@material-ui/core/styles";
import { Modal } from "@material-ui/core";
import theme from "../../Tools/SharedMuiTheme";

interface IProps extends WithStyles {
  width: number;
}

export const STModal = styled(Modal)`
  && {
    ${theme.breakpoints.only("xs")} {
      overflow-y: scroll;
    }
  }
`;

export const STWrapperModal: React.ComponentType<IProps> = styled.div`
  border-radius: 5px;
  box-sizing: border-box;

  position: absolute;
  min-width: ${(props: IProps) => props.width}px;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  background-color: #fff;
  padding: 15px;
  outline: none;

  display: flex;
  justify-content: center;
  align-items: center;

  ${theme.breakpoints.only("xs")} {
    min-width: 90%;
    width: 90%;
  }

  ${theme.breakpoints.only("sm")} {
    min-width: 400px;
  }
`;
